<template lang="pug">
md-layout.publication-container(md-flex='100')
  md-layout.date-container(md-flex='85')
    .label {{ label }}
    md-input-container(:class='{ "md-input-invalid" : formSubmitted && validation.$invalid }')
      md-input(v-model='dateTime' @change='onDateTimeChange' placeholder='Ex: 09-16-2024' type='datetime-local')
      span.md-error(v-if='formSubmitted && !validation.validDate') Invalid date format
      span.md-error(v-if='formSubmitted && !validation.isFutureDate') Date must be later than today
  md-layout(md-flex='10')
    md-button#btnCleanDate.md-icon-button(@click='cleanDate')
      md-icon(md-iconset='fa fa-eraser')
</template>

<script>
  export default {
    data() {
      return {
        dateTime: null,
        timeZone: null
      };
    },
    props: {
      publicationDate: {
        type: Object,
        default: () => ({
          date: null,
          timeZone: null
        })
      },
      label: {
        type: String,
        default: 'Date and Time'
      },
      validation: {
        type: Object,
        required: true
      },
      formSubmitted: {
        type: Boolean,
        default: false
      },
      status: {
        type: String,
        default: 'draft'
      }
    },
    methods: {
      onDateTimeChange(dateTime) {
        this.emitCombinedValue(dateTime);
      },
      emitCombinedValue(dateTime) {
        const checkDate = !dateTime ? null : dateTime.slice(0, 16) + ':00.000Z';
        this.$emit('publicationDateEmit', { date: checkDate, timeZone: checkDate ? this.timeZone : null });
      },
      cleanDate() {
        this.emitCombinedValue(null);
      },
      formatDate(date) {
        if (!date) return null;
        return date.slice(0, 16);
      }
    },
    mounted() {
      this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.dateTime = this.formatDate(this.publicationDate.date);
    },
    watch: {
      publicationDate(newValue) {
        this.dateTime = this.formatDate(newValue.date);
      },
      status(newValue) {
        if (newValue !== 'draft') {
          this.cleanDate();
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .label {
    margin-bottom: -15px;
  }
  .date-container {
    margin-right: 20px;
  }
  .publication-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/DateInputTime.vue